import { apiRequest } from '../utils/api';

export const confirmSession = (sessionId) =>
  apiRequest(`/api/onboarding-wizard/sessions/${sessionId}/confirm`, { method: 'POST', body: JSON.stringify({}) });
